import { Skeleton } from "src/@/components/ui/skeleton";

// ----------------------------------------------------------------------

export default function SkeletonKanbanColumn() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 w-full">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="border border-dashed border-gray-200 p-4 rounded-xl w-full min-w-[280px] space-y-4">
          <Skeleton className="h-[200px] w-full rounded-xl bg-gray-200" />
          {index === 0 && (
            <Skeleton className="h-[80px] w-full rounded-xl bg-gray-200" />
          )}
          {index !== 2 && (
            <Skeleton className="h-[80px] w-full rounded-xl bg-gray-200" />
          )}
        </div>
      ))}
    </div>
  );
}
